import React from 'react';

import { Link } from 'react-router-dom';
import Logo from '../../Common/components/Logo';
import images from '../../Common/Images';
import { StaticRoutePaths } from '../../Common/ClientRoutes';

import LocalizedStrings from 'react-localization';
import { translations } from '../../Common/Translations';
import localStorage from '../../Common/LocalStorage';

let strings = new LocalizedStrings(translations);

const Login = props => {
    const credentialsAlert = (credentials, errorMsg) => (credentials ? null : <div className="Error-message">{errorMsg}</div>);

    const clickHandler = () => {
        props.loginHandler();
    };

    const pressHandler = e => {
        if (e.key === 'Enter') {
            props.loginHandler();
        }
    };

    if (localStorage.getFromStorage('lang') === undefined) {
        localStorage.saveInStorage('lang', navigator.language.substring(0, 2));
    }

    strings.setLanguage(localStorage.getFromStorage('lang'));

    return (
        <div className="container">
            <div className="login-container row" onKeyPress={pressHandler}>
                <div className="col-6 offset-3">
                    <div className="row">
                        <div className="col-12 text-center">
                            <div className="logo">
                                <Logo url={images.LOGIN_LOGO} />
                            </div>
                        </div>

                        <div className="col-12 text-center">
                            <h1 className="login-title text-uppercase">{strings.login}</h1>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 qf-mb-30">
                            <div className="form-container">
                                <input
                                    className="username-input input"
                                    placeholder={strings.email}
                                    id="username"
                                    type="text"
                                    onChange={props.updateUsername}
                                />

                                <input
                                    className="password-input input"
                                    placeholder={strings.password}
                                    id="password"
                                    type="password"
                                    onChange={props.updatePassword}
                                />

                                <input className="logged-checkbox input" id="logged-in" type="checkbox" />
                                <label className="checkbox-label" htmlFor="logged-in">
                                    {strings.keep_me}
                                </label>

                                {credentialsAlert(props.validCredentials, props.credentialsErrorMsg)}

                                <input
                                    className="login-button input"
                                    id="login"
                                    value={strings.login}
                                    type="submit"
                                    onClick={clickHandler}
                                />
                            </div>

                            <div className="conditions text-center">
                                {strings.password_forgotten}{' '}
                                <Link className="link" to={StaticRoutePaths.LOGIN_FORGOTTEN_PASSWORD}>
                                    {strings.click_here}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;



// WEBPACK FOOTER //
// ./src/customModules/Login/components/Start-login.js